import script from "./tasks-board-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./tasks-board-modal.vue?vue&type=script&setup=true&lang=js"

import "./tasks-board-modal.vue?vue&type=style&index=0&id=34343f81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34343f81"]])

export default __exports__